import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";
import { reviews } from "@/mocks/reviews";
import { genreCategories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-primary-900 bg-primary-950 text-background-200">
      <div className="w-full px-4 py-12 md:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2 lg:pr-12">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-xl leading-none" />
              </span>
              <div>
                <p className="font-heading text-lg text-background-50">苍井空电影</p>
                <p className="text-[10px] uppercase tracking-[0.22em] text-background-400">
                  Sora Aoi Film Archive
                </p>
              </div>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              一个专注于苍井空影视作品整理与评析的内容站。我们收录取材、演职员、剧情简介与影迷影评，
              用清晰的资料结构与克制的文字，陪你把每一部作品看完、看懂。
            </p>
            <div className="mt-5 flex items-center gap-6 text-xs text-background-400">
              <span>{movies.length} 部作品</span>
              <span className="h-3 w-px bg-background-700" />
              <span>{reviews.length} 篇影评</span>
              <span className="h-3 w-px bg-background-700" />
              <span>每周更新</span>
            </div>
          </div>

          <div>
            <h2 className="font-heading text-sm text-background-50">浏览导航</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li>
                <Link to="/" className="transition-colors hover:text-accent-400">
                  首页焦点
                </Link>
              </li>
              <li>
                <Link to="/category" className="transition-colors hover:text-accent-400">
                  电影分类
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="transition-colors hover:text-accent-400">
                  影评资讯
                </Link>
              </li>
              <li>
                <Link to="/search?q=苍井空" className="transition-colors hover:text-accent-400">
                  全站搜索
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-accent-400">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-sm text-background-50">题材分类</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              {genreCategories.map((category) => (
                <li key={category.name}>
                  <Link
                    to={`/category?genre=${encodeURIComponent(category.name)}`}
                    className="transition-colors hover:text-accent-400"
                  >
                    {category.name}作品
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-900 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 苍井空电影 · 本站为影视资料与影评展示平台，内容仅供交流参考。</p>
          <div className="flex flex-wrap items-center gap-5">
            <Link to="/about" className="transition-colors hover:text-background-100">
              内容声明
            </Link>
            <Link to="/about#feedback" className="transition-colors hover:text-background-100">
              意见反馈
            </Link>
            <span>内容整理 · 影迷共建</span>
          </div>
        </div>
      </div>
    </footer>
  );
}